import { useEffect } from 'react';

import { DeeplinkKeys } from '@/consts/deepLinks';
import { getAppStore, setAppStore } from '@/store';
import { extractUrlParams } from '@/utils/ui/extractUrlParams';
import { normalizeCategorySlug } from '@/utils/ui/normalizeCategorySlug';

const useCategoryDeeplink = () => {
  useEffect(() => {
    // Skip if task_id or presetId is present - those handlers take priority
    const {
      [DeeplinkKeys.taskId]: taskId,
      [DeeplinkKeys.presetId]: presetId,
      [DeeplinkKeys.category]: genaicategory,
    } = extractUrlParams([
      DeeplinkKeys.category,
      DeeplinkKeys.taskId,
      DeeplinkKeys.presetId,
    ]);

    if (taskId || presetId || !genaicategory) return;

    const categorySlug = normalizeCategorySlug(genaicategory);
    if (!categorySlug) return;

    const { activeTabSlug } = getAppStore();
    setAppStore({
      ...(activeTabSlug !== categorySlug && { activeTabSlug: categorySlug }),
      screen: 'library',
      shouldScrollToActiveTab: true,
    });
  }, []);
};

export { useCategoryDeeplink };
